import { useState } from "react";
import {
  UPLOAD_PRESETS,
  validateUploadFile,
} from "../utils/validateUploadFile";
import {
  Box,
  FormControl,
  FormLabel,
  Grid,
  Input,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";
import { DOCUMENTO_COMPROVANTE_PUBLICACAO_PEDIDO } from "../utils/constants";

function DocumentosPadraoUpload({
  arquivo,
  erro,
  onFileChange,
}) {
  const theme = useTheme();
  const [erroValidacao, setErroValidacao] = useState("");
  const temErro = erro || erroValidacao;
  const temArquivo = Boolean(arquivo);

  const handleFileChange = async (event) => {
    const selected = event.target.files?.[0];
    if (!selected) return;

    event.target.value = "";

    const resultado = await validateUploadFile(selected, UPLOAD_PRESETS.documento);
    if (!resultado.valid) {
      setErroValidacao(resultado.error);
      return;
    }

    setErroValidacao("");
    if (onFileChange) {
      onFileChange(selected);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4} sx={{ display: "flex" }}>
        <FormControl
          fullWidth
          error={Boolean(temErro)}
          sx={{
            height: "100%",
            border: temArquivo
              ? `1px solid ${theme.palette.success.main}`
              : temErro
              ? `1px solid ${theme.palette.error.main}`
              : `1px solid ${alpha(theme.palette.divider, 0.6)}`,
            borderRadius: 2,
            padding: 2,
            position: "relative",
            transition: "all 0.3s",
            backgroundColor: temArquivo
              ? alpha(theme.palette.success.main, 0.05)
              : temErro
              ? alpha(theme.palette.error.main, 0.05)
              : "transparent",
            "&:hover": {
              borderColor: theme.palette.primary.main,
              boxShadow: `0 0 0 1px ${alpha(theme.palette.primary.main, 0.3)}`,
            },
          }}
        >
          <FormLabel
            sx={{
              mb: 1.5,
              display: "flex",
              alignItems: "center",
              fontWeight: "medium",
            }}
          >
            <Box
              component="span"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 24,
                height: 24,
                bgcolor: alpha(theme.palette.error.main, 0.1),
                borderRadius: "50%",
                mr: 1,
              }}
            >
              <Box component="span" sx={{ fontSize: "0.8rem" }}>
                📄
              </Box>
            </Box>
            <span style={{ flex: 1 }}>
              {DOCUMENTO_COMPROVANTE_PUBLICACAO_PEDIDO}
            </span>
            <span style={{ color: "red", marginLeft: "4px" }}> *</span>
          </FormLabel>

          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              display: "block",
              mb: 1.5,
              p: 1,
              bgcolor: alpha(theme.palette.info.main, 0.05),
              borderRadius: 1,
              borderLeft: `3px solid ${theme.palette.info.main}`,
            }}
          >
            Anexe o comprovante PDF gerado na publicação de pedido de licença.
          </Typography>

          <Box
            sx={{
              position: "relative",
              "& .MuiInput-root": {
                bgcolor: "#f8f9fa",
                border: `1px dashed ${alpha(theme.palette.text.primary, 0.2)}`,
                borderRadius: 1,
                p: 1,
                "&:hover": {
                  borderColor: theme.palette.primary.main,
                },
              },
            }}
          >
            <Input
              type="file"
              required
              onChange={handleFileChange}
              inputProps={{
                accept: ".pdf,.png,.jpg,.jpeg",
                "data-testid": "documento-padrao-comprovante-pedido",
              }}
              sx={{
                "&::before, &::after": {
                  display: "none",
                },
              }}
            />
          </Box>

          {temErro && (
            <Typography
              color="error"
              variant="caption"
              sx={{ display: "block", mt: 1 }}
            >
              {temErro}
            </Typography>
          )}

          {temArquivo && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 1.5,
                p: 1,
                borderRadius: 1,
                bgcolor: alpha(theme.palette.success.main, 0.1),
              }}
            >
              <Box
                component="span"
                sx={{
                  display: "flex",
                  mr: 1,
                  color: theme.palette.success.main,
                  fontSize: "1.2rem",
                }}
              >
                ✓
              </Box>
              <Typography
                variant="caption"
                sx={{
                  color: theme.palette.success.dark,
                  fontWeight: "medium",
                  flexGrow: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {arquivo.name}
              </Typography>
            </Box>
          )}
        </FormControl>
      </Grid>
    </Grid>
  );
}

export default DocumentosPadraoUpload;
